// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bubble-format[data-v-35c64ff4]{position:relative;display:grid;width:100%;gap:8px;height:100%}.isFullScreen .bubble-format[data-v-35c64ff4]{display:initial;margin:0;height:calc(var(--vh, 1vh)*100)}", ""]);
// Exports
module.exports = exports;
